import React from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { IParts } from 'thunks/RTKQuery/parts';
import placeholder from 'assets/images/placeholder.svg';
import i18n from 'translations';
import moment from 'moment';
import { LockIcon } from 'icons/LockIcon';
import { UnlockIcon } from 'icons/UnlockIcon';
import { API_BASE_URL } from 'api';

const getName = (row: IParts) => {
  const statusText = row.status ?? '';
  const isGreen = ['calculated', 'machined'].includes(statusText);
  let dotClass = 'parts-status-danger';
  if (statusText === '') {
    dotClass = 'parts-status-grey';
  } else if (isGreen) {
    dotClass = 'parts-status-success';
  }
  const isLocked = Boolean(row.isLocked);

  return (
    <div className="div-name">
      <span className="parts-lock-icon">
        {isLocked ? <LockIcon color="#000" /> : <UnlockIcon color="#000" />}
      </span>
      <span className="parts-name-column" title={row.name}>
        {row.name}
      </span>
      <span
        className={`prepare-parts ${dotClass}`}
        title={statusText}
        style={{ flexShrink: 0 }}
      />
    </div>
  );
};

const getPartType = (row: IParts) => {
  return (
    <div className="part-type-cell">
      <span
        className="part-type-cell__text"
        title={row.partType?.displayText ?? ''}
      >
        {row.partType?.displayText ?? ''}
      </span>
      <img
        src={
          row.partType?.imageUrl
            ? `${API_BASE_URL}${row.partType.imageUrl}`
            : placeholder
        }
        alt=""
        title={row.partType?.displayText ?? ''}
        className="part-type-cell__image"
      />
    </div>
  );
};

export const columns: ColumnDescription<any, IParts>[] = [
  {
    dataField: 'logo',
    text: '',
    style: {
      width: '100px',
    },
    formatter: (cell: any, row: IParts) => {
      return (
        <img
          src={row.logo || placeholder}
          alt=""
          className="order-image column-logo"
        />
      );
    },
  },
  {
    dataField: 'id',
    text: 'ID',
    hidden: true,
  },
  {
    dataField: 'isLocked',
    text: i18n.t('partsView.columns.isLocked'),
    sort: true,
    hidden: true,
    formatter: (cellContent: boolean | null) => {
      const isLocked = Boolean(cellContent);

      return isLocked ? (
        <LockIcon color="#000" />
      ) : (
        <UnlockIcon color="#C7CED8" /> // or red dc3545
      );
    },
  },
  {
    dataField: 'name',
    text: i18n.t('partsView.columns.name'),
    sort: true,
    formatter: (cell: any, row: IParts) => {
      return getName(row);
    },
  },
  {
    dataField: 'partType',
    text: i18n.t('partsView.columns.partType'),
    style: {
      width: '200px',
    },
    formatter: (cell: any, row: IParts) => {
      return getPartType(row);
    },
    sort: true,
  },
  {
    dataField: 'height',
    text: i18n.t('partsView.columns.height'),
    sort: true,
    hidden: true,
  },
  {
    dataField: 'path',
    text: i18n.t('partsView.columns.path'),
    sort: true,
    hidden: true, // move to details view
  },
  {
    dataField: 'projectFolder',
    text: i18n.t('partsView.columns.projectFolder'),
    sort: true,
  },
  {
    dataField: 'intendedColor',
    text: i18n.t('partsView.columns.intendedColor'),
    sort: true,
  },
  {
    dataField: 'lotNumber',
    text: i18n.t('partsView.columns.lotNumber'),
    sort: true,
  },
  {
    dataField: 'intendedMaterial',
    text: i18n.t('partsView.columns.intendedMaterial'),
    sort: true,
  },
  {
    dataField: 'machineName',
    text: i18n.t('partsView.columns.machineName'),
    sort: true,
    hidden: true, // move to details view
  },
  {
    dataField: 'created_at',
    text: i18n.t('partsView.columns.createdAt'),
    formatter: (_cell: any, row: IParts) => {
      return moment(row.created_at).format('DD.MM.YYYY HH:mm');
    },
    sort: true,
  },
  {
    dataField: 'updated_at',
    text: i18n.t('partsView.columns.updatedAt'),
    sort: true,
    hidden: true,
  },
  {
    dataField: 'customProps',
    text: 'Custom Props',
    formatter: (cell: Record<string, unknown>) => JSON.stringify(cell),
    hidden: true,
  },
  {
    dataField: 'millId',
    text: 'Mill ID',
    hidden: true,
  },
  {
    dataField: 'actions',
    text: '',
    isDummyField: true,
  },
];
